import styled from "styled-components"

export const UploadingTableContainer = styled.section`
  padding-top: 10px;
`